import React from "react"
import * as Style from "./newsItem.module.css"
import { useTranslation } from "gatsby-plugin-react-i18next"

export function NewsItem({ news }) {
  const { index, date, title, preview, content, contentZH, titleZH, link, linkZH } = news

  const { t } = useTranslation()
  const current = t("menu.lang")
  return (
    <div className={Style.newsItem}>
      <div className={Style.guide}>
        <div className={Style.index}>{index}</div>
        <div className={Style.date}>{date}</div>
      </div>
      <div className={Style.detail}>
        <div className={Style.header}>
          <span>{current === "zh" ? (linkZH ? <a target="_blank" href={linkZH}>{titleZH}</a> : titleZH) : (link ? <a target="_blank" href={link}>{ title}</a>: title)}</span>
        </div>
        <div className={Style.body}>
          {preview && <div className={Style.preview}>{preview}</div>}
          <p className={Style.content}>
            {current === "zh" ? contentZH : content}
          </p>
        </div>
      </div>
    </div>
  )
}
